import React from "react";

const TextAreaField = ({ label, name, placeholder, register, error }) => {
  return (
    <div>
      <label className="text-Primary text-sm">{label}</label>

      <textarea
        rows={4}
        placeholder={placeholder}
        {...register(name)}
        className="focus:border-primary w-full border-b border-gray-300 bg-transparent py-2 text-sm outline-none"
      />

      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
};

export default TextAreaField;
